import * as light from "../../../themes/light.json";
import * as dark from "../../../themes/dark.json";
import * as joint from "@clientio/rappid";

export class PreferenceStore extends joint.mvc.Model {
  public static INSTANCE: PreferenceStore = new PreferenceStore();

  defaults() {
    return {
      showTransitionPriorities: false,
      enableSnaplines: true,
      lightTheme: light["default"],
      darkTheme: dark["default"],
      theme: light["default"],
      gridEnabled: false,
      gridShow: false,
      gridSize: 10,
      isDark: false,
      showDocumentation: false,
      isReadOnly: false,
      linkRouter: "orthogonal" /* orthogonal */,
      horizontalNodeDistance: 120,
      verticalNodeDistance: 80,
    };
  }

  get linkRouter() {
    return super.get("linkRouter");
  }

  set linkRouter(value: string) {
    super.set("linkRouter", value);
  }

  get horizontalNodeDistance() {
    return super.get("horizontalNodeDistance");
  }

  set horizontalNodeDistance(value: number) {
    super.set("horizontalNodeDistance", value);
  }
  get verticalNodeDistance() {
    return super.get("verticalNodeDistance");
  }

  set verticalNodeDistance(value: number) {
    super.set("verticalNodeDistance", value);
  }

  get isReadOnly() {
    return super.get("isReadOnly");
  }

  set isReadOnly(readOnly: boolean) {
    super.set("isReadOnly", readOnly);
  }

  get showTransitionPriorities() {
    return super.get("showTransitionPriorities");
  }
  set showTransitionPriorities(show: boolean) {
    super.set("showTransitionPriorities", show);
  }

  get enableSnaplines() {
    return super.get("enableSnaplines");
  }

  set enableSnaplines(enable: boolean) {
    super.set("enableSnaplines", enable);
  }

  get theme() {
    return super.get("theme");
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set theme(theme: any) {
    theme.isDark ? super.set("darkTheme", theme) : super.set("lightTheme", theme);

    super.set("theme", theme);

    joint.setTheme(theme.isDark ? "dark" : "default");
  }

  get lightTheme() {
    return super.get("lightTheme");
  }

  get darkTheme() {
    return super.get("darkTheme");
  }

  enableDarkTheme() {
    super.set("theme", super.get("darkTheme"));
  }
  enableLightTheme() {
    super.set("theme", super.get("lightTheme"));
  }

  get gridEnabled() {
    return super.get("gridEnabled");
  }

  set gridEnabled(enable: boolean) {
    super.set("gridEnabled", enable);
  }

  get gridShow() {
    return super.get("gridShow");
  }

  set gridShow(enable: boolean) {
    super.set("gridShow", enable);
  }

  get gridSize() {
    return super.get("gridSize");
  }

  set gridSize(value: number) {
    super.set("gridSize", value);
  }

  get isDark() {
    return super.get("isDark");
  }

  set isDark(enable: boolean) {
    super.set("isDark", enable);
  }
}
